import React from 'react';

export default function conditionallyRequired<T>(
  propType: React.Requireable<T>,
  condition: (props: object) => boolean
): React.Validator<T> {
  return (props, key, componentName, ...args: [string, string]) => {
    if (!condition(props)) {
      return propType(props, key, componentName, ...args);
    } else {
      return propType.isRequired(props, key, componentName, ...args);
    }
  };
}
